import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type NavigationLinkPlacement =
  | 'breadcrumb'
  | 'product_information'
  | 'related_categories';

export type NavigationLinkTargetProperties = {
  destination_path: string;
  placement: NavigationLinkPlacement;
  position: number;
};

type EventData = {
  destinationPath: string;
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  placement: NavigationLinkPlacement;
  position: number;
};

class NavigationLinkInteractionEvent extends InteractionEvent<
  EventData,
  NavigationLinkTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'navigation_link';
  }

  // Every control this fires from navigates away, and the breadcrumbs and related-category
  // buttons are plain anchors that unload the document as the beacon leaves.
  protected get keepalive(): boolean {
    return true;
  }

  protected getTargetProperties(): NavigationLinkTargetProperties {
    return {
      destination_path: this.destinationPath(),
      placement: this.data.placement,
      position: this.data.position
    };
  }

  // The href as rendered minus the origin: pathname plus any query string, so a womens
  // department crumb keeps its ?gender=womens and the value joins to the destination view's
  // page_path. CAPI hands the client paths, so this only ever strips an origin that a control
  // happened to render absolute.
  private destinationPath(): string {
    const url = new URL(
      this.data.destinationPath,
      'https://placeholder.invalid'
    );

    return `${url.pathname}${url.search}`;
  }
}

export default NavigationLinkInteractionEvent;
